export interface SiteModel {
  siteId?: number;
  siteName: string;
  siteAddress?: string;
  isSiteSelected?: boolean;
}
